import { posthog } from 'posthog-js';

export type PosthogEvent = {
  name: string;
  properties?: Record<string, any>;
};

export const usePosthogEvent = () => {
  const trackEvent = (event: PosthogEvent) => {
    try {
      posthog.capture(event.name, event.properties);
    } catch (error) {
      console.error('[PostHog] Failed to track event:', error);
    }
  };

  // Common events
  const trackButtonClick = (buttonName: string, properties?: Record<string, any>) => {
    trackEvent({
      name: 'button_clicked',
      properties: {
        button_name: buttonName,
        ...properties,
      },
    });
  };

  const trackPageView = (pageName: string, properties?: Record<string, any>) => {
    trackEvent({
      name: 'page_viewed',
      properties: {
        page_name: pageName,
        ...properties,
      },
    });
  };

  const trackFeatureUsage = (featureName: string, properties?: Record<string, any>) => {
    trackEvent({
      name: 'feature_used',
      properties: {
        feature_name: featureName,
        ...properties,
      },
    });
  };

  const trackError = (errorType: string, errorMessage: string, properties?: Record<string, any>) => {
    trackEvent({
      name: 'error_occurred',
      properties: {
        error_type: errorType,
        error_message: errorMessage,
        ...properties,
      },
    });
  };

  const trackSearch = (searchTerm: string, properties?: Record<string, any>) => {
    trackEvent({
      name: 'search_performed',
      properties: {
        search_term: searchTerm,
        ...properties,
      },
    });
  };

  const trackFormSubmission = (formName: string, properties?: Record<string, any>) => {
    trackEvent({
      name: 'form_submitted',
      properties: {
        form_name: formName,
        ...properties,
      },
    });
  };

  return {
    trackEvent,
    trackButtonClick,
    trackPageView,
    trackFeatureUsage,
    trackError,
    trackSearch,
    trackFormSubmission,
  };
};

export default usePosthogEvent;
